import {Box, styled} from '@mui/material';

export const Avatar = styled(Box)(({selected, theme}) => ({
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(1),
  backgroundColor: theme.vars.palette.action.selected,
  color: theme.vars.palette.action.disabled,
  display: 'inline-flex',
  width: 48,
  height: 48,
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  border: `solid 1px ${
    selected
      ? theme.vars.palette.primary.main
      : theme.vars.palette.action.selected
  }`,
  '& .hoverControls': {
    display: 'none',
  },
  '&:hover .hoverControls': {
    display: 'block',
  },
}));
